import { keyframes } from 'styled-components';
import { transparentize as fade } from 'polished';
var keyframeFadeIn = /*#__PURE__*/keyframes(["0%{opacity:0;}100%{opacity:1}"]);
var placeHolderShimmer = /*#__PURE__*/keyframes(["0%{background-position:-468px 0}100%{background-position:468px 0}"]);
var keyframeSlideFromBottom = function keyframeSlideFromBottom(translateY) {
  return keyframes(["0%{transform:translateY(100vh);}100%{transform:translateY(", "px;);}"], translateY);
};
var keyframeSlideFromRight = function keyframeSlideFromRight(translateX) {
  return keyframes(["0%{transform:translateX(100vw);}100%{transform:translateX(", "px;);}"], translateX);
};
var keyframeSlideBackFromRight = function keyframeSlideBackFromRight(translateX) {
  return keyframes(["0%{transform:translateX(", "px;);}100%{transform:translateX(100vw);}"], translateX);
};
function pulsate(color) {
  return keyframes(["0%{box-shadow:0 0 0 0 ", ";}70%{box-shadow:0 0 0 0.5rem ", ";}100%{box-shadow:0 0 0 0 ", ";}"], fade('0.4', color), fade('1', color), fade('1', color));
}
function lightUp(color) {
  return keyframes(["0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}"], fade('1', color), fade('0.85', color), fade('1', color));
}
export { keyframeFadeIn, keyframeSlideBackFromRight, keyframeSlideFromBottom, keyframeSlideFromRight, lightUp, placeHolderShimmer, pulsate };